// extracted by mini-css-extract-plugin
module.exports = {"label":"SortLabel_label__1tSDd","icon":"SortLabel_icon__21Oxk","label--selected":"SortLabel_label--selected__xEdro"};